import { Popper, Grow, Paper, ClickAwayListener, MenuList, PopperProps } from '@mui/material';

interface Props extends PopperProps {
  setOpen: Function;
  custom?: boolean;
}

export default function ContextMenu(props: Props) {
  const { setOpen, custom, ...restProps } = props;
  return (
    <Popper role={undefined} transition style={{ zIndex: 2000 }} {...restProps}>
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: 'center top'
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={() => props.setOpen(false)}>
              {props.custom ? (
                (props.children as any)
              ) : (
                <MenuList>{<>{props.children}</>}</MenuList>
              )}
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}
